import { Core } from 'chessboard/core/config/types';

/**
 * Determine whether or not the state machine should ignore an event.
 */
export function shouldIgnoreEvent(eventType: Core.APIEvents): boolean {
  return [
    Core.APIEvents.AddMove,
    Core.APIEvents.BlinkHighlight,
    Core.APIEvents.ClearMarkings,
    Core.APIEvents.Mark,
    Core.APIEvents.LineUpdated,
    Core.APIEvents.NodeUpdated,
    Core.APIEvents.Unmark,
    Core.APIEvents.UpdatePGNHeaders,
  ].includes(eventType);
}
